import api from "./axios";

export const PremiumMatches = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/home/premium-matches/", {
    params,
  });
  return response.data.data;
};

export const ProfileCompletion = async () => {
  const response = await api.get("/users/home/common-data");

  console.log(response.data.data, "home data");

  return response.data.data;
};

export const BlogList = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/blogs/blogs/listing", {
    params,
  });
  return response.data.data;
};

export const SuccessStories = async ({ queryKey }) => {
  const [_key, { page, limit, see_all, id, search_key }] = queryKey;
  const response = await api.get("/blogs/success-stories/", {
    params: { page, limit, see_all, id, search_key },
  });
  return response.data.data.success_stories;
};

export const requestAlbum = async (payload) => {
  const response = await api.post("/user_preference/request-album", payload);
  return response.data;
};

export const reqContact = async (payload) => {
  const response = await api.post("/user_preference/request-contact", payload);
  return response.data;
};

export const sendInterest = async (payload) => {
  const response = await api.post(
    "/user_preference/user-interest-request-handle",
    payload,
  );
  return response.data;
};

export const messageRequest = async (payload) => {
  const response = await api.post("/user_preference/message-request", payload);
  return response.data;
};

export const cancelInterest = async (payload) => {
  const response = await api.post(
    "/user_preference/cancel-interest-request",
    payload,
  );
  return response.data;
};

export const marknoInterested = async (payload) => {
  const response = await api.post("/user_preference/mark-no-interest", payload);
  return response.data;
};

export const markFavourite = async (payload) => {
  const response = await api.post(
    "/user_preference/favourite/status-update/",
    payload,
  );
  return response.data;
};

export const RecommendedProfiles = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/engage/admin_recommended-profiles/", {
    params,
  });
  return response.data.data;
};

export const LatestProfiles = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/home/latest-matches/", {
    params,
  });
  return response.data.data;
};

// export const contactRequests = async (payload) => {
//   const response = await api.post(
//     "/user_preference/contact-request-status-update",
//     payload
//   );
//   return response.data;
// };

export const albumRequests = async (payload) => {
  const response = await api.post(
    "/user_preference/album-request-status-update",
    payload,
  );
  return response.data;
};

export const interestRequests = async (payload) => {
  const response = await api.post(
    "/user_preference/interest-request-status-update",
    payload,
  );
  return response.data;
};
